export const ENABLE_GA = 'EnableGA';
export const ENABLE_AMPLITUDE = 'EnableAmplitude';
export const ENABLE_PREFERENCE_CENTER = 'EnablePreferenceCenter';
export const ENABLE_FW_UPDATES_CHECK = 'EnableFWUpdatesCheck';
export const ENABLE_BLE_EXPERIENCE_DATA_COLLECTION = 'EnableBLEExperienceDataCollection';
export const ENABLE_BLE_LIFE_DATA_DATA_COLLECTION = 'EnableBLELifeDataDataCollection';
export const ENABLE_BLE_ERROR_DATA_COLLECTION = 'EnableBLEErrorDataCollection';
export const ENABLE_BLE_ERROR_LOG_DATA_COLLECTION = 'EnableBLEErrorLogDataCollection';
export const ENABLE_BLE_PUFF_DATA_DATA_COLLECTION = 'EnableBLEPuffDataDataCollection';
export const NON_ANONYMIZE_DATA = 'NonAnonymizeData';
export const ENABLE_USAGE_HISTORY_DISPLAY = 'EnableUsageHistoryDisplay';
export const ENABLE_ERRORS_DISPLAY = 'EnableErrorsDisplay';
